import { motion } from 'framer-motion';
import { Hammer, Wrench, Droplet, Zap, Home, Paintbrush } from 'lucide-react';

const industries = [
  { icon: Hammer, label: 'Contractors', color: 'text-brand-primary' },
  { icon: Wrench, label: 'HVAC', color: 'text-blue-400' },
  { icon: Droplet, label: 'Plumbing', color: 'text-cyan-400' },
  { icon: Zap, label: 'Electrical', color: 'text-yellow-400' },
  { icon: Home, label: 'Remodeling', color: 'text-purple-400' },
  { icon: Paintbrush, label: 'Painting', color: 'text-green-400' },
];

export const IndustryBadges = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6"
    >
      <span className="text-xs text-slate-500 font-medium uppercase tracking-wider">
        Trusted By:
      </span>
      {industries.map((industry, index) => (
        <motion.div
          key={industry.label}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.1, duration: 0.3 }}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-brand-base/50 border border-brand-border/50 hover:border-brand-primary/30 transition-colors group"
        >
          <industry.icon className={`w-3.5 h-3.5 ${industry.color} group-hover:scale-110 transition-transform`} />
          <span className="text-xs text-slate-300 font-medium">{industry.label}</span>
        </motion.div>
      ))}
    </motion.div>
  );
};
